import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'
import StorageUtil from './storage'

const service = axios.create({
  // baseURL: 'https://m1.apifoxmock.com/m1/8918738-8719619-default',
  baseURL: '/api',
  timeout: 15000,
  headers: {'Content-Type': 'application/json;charset=utf-8'},
  withCredentials: false
})


let tokenCache = null;
if (window.tokenCache) {
  tokenCache = window.tokenCache;
} else {
  const storedToken = StorageUtil.getItemSync('token');
  if (storedToken) {
    tokenCache = storedToken;
    window.tokenCache = storedToken;
  } else {
    window.tokenCache = null;
  }
}

export function setTokenCache(token) {
  tokenCache = token;
  window.tokenCache = token;
  if (token) StorageUtil.setItem('token', token);
  else StorageUtil.removeItem('token');
}

service.interceptors.request.use(
  config => {
    // 客户端标识
    config.headers['X-Client-Type'] = 'CHEMICAL_APP';
    const path = router.currentRoute.path;
    if (path.endsWith('public-key')) {
      // 获取公钥直接放行
      return config;
    }

    let effectiveToken = tokenCache || window.tokenCache || StorageUtil.getItemSync('token');

    if (effectiveToken) {
      tokenCache = effectiveToken;
      window.tokenCache = effectiveToken;
      config.headers['Authorization'] = `Bearer ${effectiveToken}`;
      config.headers['token'] = effectiveToken;
    }
    return config
  },
  error => {return Promise.reject(error)}
)

service.interceptors.response.use(
  response => {
    const res = response.data
    // console.log('88888',res.code)
    if (res.code !== 200 && res.code !== "0000" && response.data == undefined && res.code != 0) {
      Message.error(res.message || res.msg || '请求失败');
      return Promise.reject(res);
    }
    return res
  },
  error => {
      const traceId =  error.response.headers['x-trace-id']
    if (error.response?.status === 401 || error.response?.data?.code === 401) {
      tokenCache = null;
      window.tokenCache = null;
      StorageUtil.removeItem('token');
      StorageUtil.removeItem('menus');
      StorageUtil.removeItem('auth_codes');
      // 防重入：避免多个 401 同时触发多次 push 造成 "Navigation cancelled" 警告
      if (router.currentRoute.path !== '/login' && !window.__loginRedirecting) {
        window.__loginRedirecting = true;
        Message.error('登录过期，请重新登录');
        setTimeout(() => {
          router.push('/login').finally(() => {
            // 1.5s 后释放标志，允许后续真正需要时再次跳转
            setTimeout(() => { window.__loginRedirecting = false; }, 1500);
          });
        }, 300);
      }
    } else if (error.response) {
      Message.error(`${error.response.data?.message} ${traceId}` || `服务器错误[${error.response.status}]`,{duration:3000});
    } else {
      Message.error('网络异常，请检查网络或后端配置');
    }
    return Promise.reject(error);
  }
)

export default service
